import checkEnv from "../../build-tools/checkEnv"
import applyStoryblokMappers from "../services/StoryblokFilter/applyStoryblokMappers"

export default ({ app, isDev, $config }, inject) => {
  const serveDrafts =
    isDev ||
    app.context.$preview ||
    process.env.TARGET_ENV !== "production" ||
    checkEnv.isNonProd()
  const draftOrPublished = serveDrafts ? "draft" : "published"

  const watchStoryblokChanges = (inputCallback, contentVersion) => {
    app.$storybridge(() => {
      const storyblokInstance = new StoryblokBridge()

      storyblokInstance.on(["input", "published", "change"], event => {
        if (event.action === "input") {
          event.story = applyStoryblokMappers.applyMappers(
            event.story,
            contentVersion
          )
          inputCallback(event)
        } else {
          app.router.go({
            path: app.router.currentRoute,
            force: true
          })
        }
      })
    })
  }

  const helper = {
    get: async ({ project = "", id = "", version = "1", ...params }) => {
      const { data, headers } = await app.$storyapi.get(
        `cdn/stories/${project}${id}`,
        {
          version: draftOrPublished,
          ...params
        }
      )
      applyStoryblokMappers.applyMappers(data.story, version)

      if (params.starts_with === "blog/") {
        return { ...data, total: headers.total }
      }
      return data
    },
    getDataSource: async id => {
      const { data } = await app.$storyapi.get(
        `cdn/datasource_entries?datasource=${id}`
      )
      return data.datasource_entries
    },
    onInput: (inputCallback, contentVersion) => {
      watchStoryblokChanges(inputCallback, contentVersion)
    }
  }

  if (process.server && $config.target === "static") {
    // Configures axios instance used by Storyblok client
    // to fix build error taking place in CI environment
    const https = require("https")
    app.$storyapi.client.defaults.httpsAgent = new https.Agent({
      keepAlive: true
    })
  }
  inject("storyblokHelper", helper)
}
